import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";
import { apiCaller } from "../functions";

export function useConsentApi() {
    const callApi = useApiCall();

    return {
        getConsentContent: apiCaller(callApi, SAGA_ACTIONS.CONSENT.GET_CONTENT),
        getMerchantConsent: apiCaller(callApi, SAGA_ACTIONS.CONSENT.GET_MERCHANT),
        acceptMerchantConsent: apiCaller(callApi, SAGA_ACTIONS.CONSENT.ACCEPT_MERCHANT),
        getSmsPreference: apiCaller(callApi, SAGA_ACTIONS.CONSENT.GET_SMS_PREFERENCE),
        saveSmsPreference: apiCaller(callApi, SAGA_ACTIONS.CONSENT.SAVE_SMS_PREFERENCE),
    };
}
